import { graphql } from '@/gql';
import type { PaginationInputType } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedUnpaidGroceryOrderResponse } from '@/models/grocery';

export const fetchUnpaidGroceryOrders = async ({
  pagination,
}: {
  pagination: PaginationInputType;
}): Promise<PaginatedUnpaidGroceryOrderResponse> => {
  const response = await queryExecute({
    variables: {
      pagination,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query UnpaidGroceryOrders($pagination: PaginationInputType) {
        unpaidGroceryOrders(pagination: $pagination) {
          rows {
            orderId
            customerName
            customerPhone
            totalCost
            timeCompleted
            email
            lastPaymentFailedTime
          }
          count
        }
      }
    `),
  });

  return response.data.unpaidGroceryOrders;
};
